import React, { FC } from 'react'
import styles from 'styles/components/button.module.scss'

type Props = {
  dataCy?: string
  disabled?: boolean
  onClick: () => void
}

const DeleteIconButton: FC<Props> = (props) => {
  const { dataCy, disabled, onClick } = props
  const dataCyStr = dataCy ? `delete-icon-button-${dataCy}` : 'delete-icon-button'

  return (
    <button
      className={disabled ? styles.button__delete_disabled : styles.button__delete}
      data-cy={dataCyStr}
      onClick={() => (disabled ? null : onClick())}
    >
      <img src={disabled ? '/icon/grey/delete_28x28.svg' : '/icon/blue/delete_28x28.svg'} alt={'削除'} />
    </button>
  )
}

export default DeleteIconButton
